import type { UserStateEntry, UserStateMap } from "../../types/user-state";
import { isUserStateItemKey } from "../../types/user-state";
import { normalizeUserStateVersion } from "./normalize-user-state-version";

/**
 * Drops persisted or merged userState entry keys that the API will reject.
 * Invalid keys often come from legacy bugs, manual storage edits, or partial prefixes
 * (e.g. `viewedJob` without `#${jobId}` → requests to `/api/user-state/viewedJob`).
 */
export function sanitizeUserStateEntries(entries: UserStateMap): {
  sanitized: UserStateMap;
  droppedKeys: string[];
} {
  const sanitized: UserStateMap = {};
  const droppedKeys: string[] = [];

  for (const [key, entry] of Object.entries(entries)) {
    if (isUserStateItemKey(key)) {
      const e = entry as UserStateEntry;
      sanitized[key] = {
        ...e,
        version: normalizeUserStateVersion(e.version),
      };
    } else {
      droppedKeys.push(key);
    }
  }

  return { sanitized, droppedKeys };
}
